import { render, staticRenderFns } from "./ShowTimetablePrismaS.vue?vue&type=template&id=a3e113ba&"
import script from "./ShowTimetablePrismaS.vue?vue&type=script&lang=js&"
export * from "./ShowTimetablePrismaS.vue?vue&type=script&lang=js&"
import style0 from "./ShowTimetablePrismaS.vue?vue&type=style&index=0&id=a3e113ba&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCalendar,VCard,VCardTitle,VCol,VContainer,VIcon,VProgressCircular,VRow,VSpacer})
